import { IPlayer } from "./abstraction/IPlayer";


export class MixedPlayer implements IPlayer {

    protected _players: IPlayer[];

    constructor(...players: IPlayer[]) {
        this._players = players;
    }

    async playAsync(): Promise<void> {
        await Promise.all(this._players.map(a => a.playAsync()));
    }

    async pauseAsync(): Promise<void> {
        await Promise.all(this._players.map(a => a.pauseAsync()));
    }

    async stopAsync(): Promise<void> {
        await Promise.all(this._players.map(a => a.stopAsync()));
    }

    async setPositionAsync(posSec: number): Promise<void> {
        await Promise.all(this._players.map(a => a.setPositionAsync(posSec)));
    }

    get position() {
        return this._players[0].position;
    }

    get state() {
        return this._players[0].state;
    }
}